import React from 'react';
import { Button } from './Button.jsx'

function LinkButton(props) {
    return <Button renderAsLink={true} {...props}>{props.children}</Button>
}

export default LinkButton;